import { convertToSnakeCase } from './convert-keys-to-snake-case'
import { invariant } from './invariant'

export class EventNameBuilder {
  _prefix = ''
  _page = ''
  _component = ''
  _action = ''
  _separator = '_'

  /**
   * @param {string} value - The prefix value.
   * @returns {EventNameBuilder} The instance of the builder.
   * @throws {Error} Throws an error if the value is null or undefined.
   */
  prefix(value) {
    invariant(value, 'Prefix cannot be null or undefined')
    this._prefix = value
    return this
  }

  /**
   * @param {string} value - The page value.
   * @returns {EventNameBuilder} The instance of the builder.
   * @throws {Error} Throws an error if the value is null or undefined.
   */
  page(value) {
    invariant(value, 'Page cannot be null or undefined')
    this._page = value
    return this
  }

  /**
   * @param {string} value - The component value.
   * @returns {EventNameBuilder} The instance of the builder.
   * @throws {Error} Throws an error if the value is null or undefined.
   */
  component(value) {
    this._component = value
    return this
  }

  /**
   * @param {string} value - The action value.
   * @returns {EventNameBuilder} The instance of the builder.
   * @throws {Error} Throws an error if the value is null or undefined.
   */
  action(value) {
    invariant(value, 'Action cannot be null or undefined')
    this._action = value
    return this
  }

  /**
   * @param {string} value - The separator value.
   * @returns {EventNameBuilder} The instance of the builder.
   * @throws {Error} Throws an error if the value is null or undefined.
   */
  separator(value) {
    invariant(value, 'Separator cannot be null or undefined')
    this._separator = value
    return this
  }

  /**
   * @returns {string} The constructed event name in snake_case.
   */
  build() {
    const parts = [this._prefix, this._page, this._component, this._action]
    return convertToSnakeCase(
      parts.filter((part) => part).join(this._separator),
    )
  }
}
